import { render, staticRenderFns } from "./ProposalCardResponsive.vue?vue&type=template&id=3e0775ed"
import script from "./ProposalCardResponsive.vue?vue&type=script&lang=js"
export * from "./ProposalCardResponsive.vue?vue&type=script&lang=js"
import style0 from "./ProposalCardResponsive.vue?vue&type=style&index=0&id=3e0775ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports